import { Routes } from '@/routes';

export default {
	'chapter.index': () => import('@/modules/chapters/index'),
	'chapter.add': () => import('@/modules/chapters/form'),
	'chapter.edit': () => import('@/modules/chapters/form'),
} as Routes;
